import initialState from '../initialState';

/**
 * Set unjoined reducer.
 *
 * @param {Object} state Current state.
 *
 * @returns {Object} New state.
 */
export default function setUnjoined() {
  return { ...initialState };
}
